// extracted by mini-css-extract-plugin
module.exports = {"item":"CoinNav_item__LDbdF","active":"CoinNav_active__mTGkj"};